// extracted by mini-css-extract-plugin
export default {"meatball":"code-description-toolbar__meatball--u7LKu","not-allowed":"code-description-toolbar__not-allowed--NhYV8","notAllowed":"code-description-toolbar__not-allowed--NhYV8"};